
export class TaazeMediaUrlCreator {
  private baseUrl: string;

  constructor(baseUrl='https://media.taaze.tw') {
    this.baseUrl = baseUrl;
  }

  private appendQueryParams(url: string, query?: Record<string, string | number | boolean | undefined>): string {
    if (!query) return url;
    const searchParams = new URLSearchParams();
    for (const [key, value] of Object.entries(query)) {
      if (value !== undefined) {
        searchParams.set(key, String(value));
      }
    }
    const queryString = searchParams.toString();
    return queryString ? `${url}?${queryString}` : url;
  }

  createProductImageUrl(productId: string, query?: Record<string, string>): string {
    const url = `${this.baseUrl}/showThumbnail.html?sc=${productId}&height=400&width=310`;
    console.log(url);
    return this.appendQueryParams(url, query);
  }
}